export const DesignerConfig = {
    /** @type {any[]} */
    jTabs: [],
    /** @type {any[]} */
    hTabs: [],
    /** @type {any[]} */
    contr: [],
    /** @type {any[]} */
    displayField: [],
    /** @type {number} */
    server: 0,
    /** @type {number} */
    selectedPage: -1,
    /** @type {string} */
    db: '',
    /** @type {boolean} */
    designerTablesEnabled: false,
};
